import Cookies from 'js-cookie'

// 判断是否是微信环境
export const isWeiXin = () => {
  let ua = window.navigator.userAgent.toLowerCase()
  return /micromessenger/.test(ua)
}

// 判断是否是App环境
export const isApp = !!Cookies.get('is_app')
// 当前平台
export const platform = Cookies.get('platform') || ''

var u = window.navigator.userAgent
export const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1 // android终端或者uc浏览器
export const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
